import { createContext, type RefObject } from 'react';
import type { Canvas } from 'fabric';

export interface FabricCanvasContextValue {
  canvasRef: RefObject<Canvas | null>;
}

export const FabricCanvasContext = createContext<FabricCanvasContextValue | null>(null);
